export default __webpack_public_path__ + "static/media/randomizer.55120191.png";